import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import { useI18n } from '../../../lib/hook/useI18n';
import PrivacyPolicyLink from '../../ConsentPromp/PrivacyPolicyLink';

interface Props {
  actionText: string;
  mentionsEmail?: boolean;
  showInfoIcon?: boolean;
}

const UnifiedConsentIdentityInfoNote: React.FC<Props> = ({
  actionText,
  mentionsEmail = true,
  showInfoIcon = true,
}) => {
  const { i18nClasses, tc } = useI18n();

  const messageKey = mentionsEmail
    ? 'room.welcome.modal.unified.identity_verification_note'
    : 'room.welcome.modal.unified.identity_verification_note_passcode_only';

  return (
    <Box display="flex" alignItems="flex-start" gap={1}>
      {showInfoIcon ? (
        <InfoOutlined
          color="action"
          fontSize="small"
          sx={{ flexShrink: 0, mt: 0.25 }}
        />
      ) : null}
      <Typography
        className={i18nClasses.root}
        color="textSecondary"
        component="span"
        variant="body2"
      >
        {tc(
          messageKey,
          { actionText },
          {
            privacyPolicyLink: (
              <PrivacyPolicyLink color="primary" variant="body2" />
            ),
          },
          true
        )}
      </Typography>
    </Box>
  );
};

export default UnifiedConsentIdentityInfoNote;
